module.exports = __webpack_public_path__ + "static/media/caraway.87d177a3.jpg";